/** @generated - do not modify this file. */

// src/schema.ts
import { schema } from "@verdant-web/store";
import cuid from "cuid";
var items = schema.collection({
  name: "item",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    content: schema.fields.string({
      default: ""
    }),
    done: schema.fields.boolean({
      default: false
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    })
  },
  indexes: {
    createdAt: {
      field: "createdAt"
    }
  }
});
var weather = schema.collection({
  name: "weather",
  primaryKey: "id",
  fields: {
    id: schema.fields.string({
      default: cuid
    }),
    date: schema.fields.string({
      default: ""
    }),
    temperature: schema.fields.string({
      default: ""
    }),
    createdAt: schema.fields.number({
      default: () => Date.now()
    })
  },
  indexes: {
    createdAt: {
      field: "createdAt"
    }
  }
});
var entries = schema.collection({
  name: "entry",
  primaryKey: "date",
  fields: {
    date: {
      type: "string",
      default: () => {
        return (/* @__PURE__ */ new Date()).toDateString();
      }
    },
    mood: {
      type: "string",
      options: ["worst", "worse", "same", "better", "best"]
    }
  },
  indexes: {
    date: {
      type: "number",
      compute: (entry) => new Date(entry.date).getTime()
    }
  }
});
var schema_default = schema({
  version: 2,
  collections: {
    items,
    entries,
    weather
  }
});
export {
  schema_default as default
};
